
import React, { useState } from "react";
import { RISK_SCORE_STANDARD } from "../../config/governancePolicy";

export const RiskScoreInfo = () => {
    const [isOpen, setIsOpen] = useState(false);
    
    return (
        <div style={{ marginBottom: 12, border: '1px solid #333', borderRadius: 8, background: 'rgba(255,255,255,0.02)', overflow: 'hidden' }}>
            <div 
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    padding: '8px 12px', 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    cursor: 'pointer',
                    fontSize: 13,
                    color: '#aaa'
                }}
            >
                <div style={{display:'flex', alignItems:'center', gap: 6}}>
                    <span>ℹ️ 風險評分計算方式說明</span>
                    <span style={{fontSize: 11, opacity: 0.7}}>(點擊{isOpen ? '收合' : '展開'})</span>
                </div>
                <div>{isOpen ? '▲' : '▼'}</div>
            </div>
            
            {isOpen && (
                <div style={{ padding: '0 12px 12px 12px', borderTop: '1px solid #333', marginTop: 0 }}>
                    <div style={{fontSize: 12, color: '#ccc', margin: '8px 0'}}>
                        <span style={{fontWeight:'bold', color:'#fff'}}>計算公式：</span> {RISK_SCORE_STANDARD.formula}
                    </div>
                    
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 8}}>
                        {RISK_SCORE_STANDARD.levels.map((l, i) => (
                            <div key={i} style={{
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'space-between', 
                                padding: '4px 8px', 
                                background: l.badgeColor, 
                                borderRadius: 4,
                                border: `1px solid ${l.color}`
                            }}>
                                <span style={{color: l.color, fontWeight:'bold'}}>{l.label}</span>
                                <span style={{color: '#fff'}}>{l.range}</span>
                            </div>
                        ))}
                    </div>
                    
                    <div style={{marginTop: 8, fontSize: 12, color: '#888'}}>
                        * 評分因子包含：主管機關權重 (如食藥署/個資權重較高)、關鍵字命中 (如罰鍰/停止營業)、公告類型 (修正/預告)。
                    </div>
                </div>
            )}
        </div>
    );
};
